import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap, faLaptopCode } from "@fortawesome/free-solid-svg-icons";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [
    "Full Stack Web Developer",
    "Web Designer",
    "UI/UX Designer",
    "MERN Developer",
    "Database Engineer",
  ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]); // Ensure 'text' is in the dependency array

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1); // Correct usage of setIndex
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1); // Reset index correctly here
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1); // Increment index correctly
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h1>
                    {`ANURAG KHANNA`} <h3>Software Engineer</h3>
                  </h1>

                  <p>
                    As a seasoned BlockChain-Software Engineer with over 1 year
                    of experience, I bring an in-depth understanding of DeFi,
                    NFTs, DAOs, dApps, blockchain oracles, EVM, cross-chain
                    bridges, layer 2 scaling solutions like optimistic and zero
                    knowledge (ZK) rollups and the wider web3 ecosystem.
                  </p>
                  <p>
                    Combining my technical proficiency with a native-level
                    English fluency, I am a skilled communicator, adept at
                    remote collaboration, and always focused on delivering
                    results in this rapidly evolving sector.
                  </p>
                  <button onClick={() => window.location.href = "https://linkedin.com/in/anuragkhanna"}>
                    Let’s Connect <ArrowRightCircle size={25} />
                  </button>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img" />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>

        {/* New Section: What I'm Doing */}
        <Row className="align-items-center mt-5">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeInLeft" : ""}>
                  <h2>What I'm Doing</h2>
                  <h3>BlockChain Engineer @SKYTRADE</h3>
                  <p>
                    Providing Solutions for drone ATC system with DePIN , DeFi , EVM , Peaq Network , SmartContracts , Blockchain Security.
                  </p>
                  <h3>B.Tech @ Indian Institute Of Information Technology</h3>
                  <p>Ready to dive deep into technical Space ?</p>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <FontAwesomeIcon icon={faGraduationCap} size="6x" />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>

        {/* New Section: Position Of Responsibilities */}
        <Row className="align-items-center mt-5">
          <Col xs={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeInLeft" : ""}>
                  <h3>Position Of Responsibilities</h3>
                  <div>
                    <FontAwesomeIcon icon={faLaptopCode} size="2x" className="mb-2" />
                  </div>
                  <div>
                    <p>Technical Head GymKhana - IIIT'M</p>
                  </div>
                  <div>
                    <p>Level-3 Contributor SuperTeamFun</p>
                  </div>
                  <div>
                    <p>Club Lead Coding Club - IIIT'M</p>
                  </div>
                  <div>
                    <p>Android Lead GDSC - IIIT'M</p>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
